<div class="wrapper">
  <div class="progress-info d-flex justify-content-between mb-1">
    <span class="title">{{ config ? config.title : "" }}</span>
    <span class="percent">{{ config ? config.percent : "" }}%</span>
  </div>

  <div class="progress-bar">
    <div class="bar" [style]="{ width: counter + '%' }"></div>
  </div>
</div>
